export const NAMESPACE = "alert-modal";

export const MODAL_PREFIX = "modal";
export const MODAL_REDIRECT_ALERT = `${MODAL_PREFIX}_redirect_alert`;
export const MODAL_REDIRECT_ALERT_CONFIRM = `${MODAL_REDIRECT_ALERT}_confirm`;
export const MODAL_REDIRECT_ALERT_CANCEL = `${MODAL_REDIRECT_ALERT}_cancel`;
